module.exports = __webpack_public_path__ + "SK.png?af7736158775dd13968e0e5030826680";